import{createModalContext}from"../modal";export const[WalletModalProvider,useWalletModalView,useWalletModalActions]=createModalContext('Wallet');